// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"a21cae66","863":"45b4e5b3"}[chunkId] + ".chunk.js";
};